<template>
    <el-dialog
        :visible="show"
        :title="$t('TABLE_HEADER_fileNameList')"
        :close-on-click-modal="false"
        append-to-body
        max-height="500"
        width="70%"
        top="10vh"
        @close="close"
    >
        <div class="filelist-container">
            <el-table :data="pageData" border max-height="500" :row-class-name="tableRowClassName" :cell-class-name="tableCellClassName">
                <el-table-column
                    v-if="getUser.userType === '1'"
                    :label="$t('milestone_file_visible_to_client')"
                    header-align="center"
                    width="60"
                    align="center"
                >
                    <template slot-scope="scope">
                        <!-- isEditVisible: {{  scope.row.isEditVisible }} isClientVisible: {{ scope.row.isClientVisible }} -->
                        <img
                            @click="changeVisiableToClient(scope.row)"
                            :class="[
                                'visible_to_client-icon',
                                !scope.row.isEditVisible || scope.row.uploadUserType === '2' ? 'visible_to_client-icon-uneditable' : ''
                            ]"
                            :src="calcVisibleIcon(scope.row)"
                            alt=""
                        />
                    </template>
                </el-table-column>

                <el-table-column :label="$t('DOWNLOAD_FILE_NAME')" header-align="center" min-width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div :class="['filename', !canDownload(scope.row) ? 'filename-disable' : '']" @click="onFilenameClick(scope.row)">
                            <i class="filename-icon el-icon-download"></i>
                            <svg-icon :icon-name="getUploadFileIcon(scope.row.uploadFilename)" :size="20"></svg-icon>
                            <span class="filename-text" style="margin-left: 3px;">{{ scope.row.uploadFilename }}</span>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    v-if="getUser.userType === '1'"
                    :label="$t('table_column_lable_milestone')"
                    header-align="center"
                    min-width="150"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        {{ scope.row.multiMilestoneName }}
                        <span class="forkpmgonly" v-show="scope.row.accessFlag == '0'">{{ $t('for_kpmg_only') }}</span>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('DOWNLOAD_SIZE')" header-align="center" align="center" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.size | fileSize }}
                    </template>
                </el-table-column>

                <el-table-column :label="$t('DOWNLOAD_TIME')" header-align="center" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.lastDownloadDate | formatDateTime }}
                    </template>
                </el-table-column>

                <el-table-column
                    :label="$t('DOWNLOAD_BY')"
                    prop="lastDownloadBy"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                ></el-table-column>

                <el-table-column :label="$t('UPLOAD_TIME')" header-align="center" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.createDate | formatDateTime }}
                    </template>
                </el-table-column>

                <el-table-column
                    :label="$t('UPLOAD_BY')"
                    prop="createBy"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column prop="action" width="70" show-overflow-tooltip align="center" :label="$t('COMMON_DELETE')">
                    <template slot-scope="scope">
                        <i class="el-icon-delete delete" v-if="allowDelete(scope.row)" @click="onDeleteClick(scope.row)" />
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="wl-pagination"
                :total="filelist.length"
                :page-size="pageSize"
                @size-change="onSizeChange"
                :page-sizes="[10, 50, 100]"
                layout="prev, pager, next, sizes, total"
                @current-change="handleCurrentChange"
            >
            </el-pagination>
        </div>
    </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import API from '@/api'
import { loading, isIE, dateFormat } from '@/utils'
import { userEntity } from '@/mixins/getUserEntity.js'
import { userPermission } from '@/mixins/userPermission.js'
import { unZipFile } from '@/utils/zip'
import { downloadSingleFile } from '@/utils/useDownload'
import SvgIcon from "@/components/svgIcon/index";
import { getFileIcon } from '../../components/data.js'

export default {
    name: 'SASFileList',
    props: {
        filelist: {
            type: Array,
            default: () => []
        },
        show: false,
        reloadList: {
            type: Function,
            default: () => {}
        }
    },
    mixins: [userEntity, userPermission],
    components: {
      SvgIcon,
    },
    data() {
        return {
            on_editable_icon: require('@/assets/img/kpicon-eye-on.svg'),
            off_editable_icon: require('@/assets/img/kpicon-eye-off.svg'),
            off_uneditable_icon: require('@/assets/img/kpicon-eye-disable.svg'),
            on_uneditable_icon: require('@/assets/img/kpicon-eye-on-disable.svg'),
            pageSize: 10,
            current: 1,
            downloadAble: false
        }
    },
    mounted() {
        this.getSiteTiles()
    },
    methods: {
        getUploadFileIcon(filename) {
          return getFileIcon(filename);
        },
        getSiteTiles() {
            API.clientUser
                .getSiteConfig({ param: this.getSite.siteId })
                .then((res) => {
                    if (res.code == '1') {
                        this.downloadAble = !!res.data.downloadable
                    }
                })
                .catch((e) => {})
                .finally(() => {})
        },
        tableCellClassName({ row, column, rowIndex, columnIndex }) {
            if (this.getUser.userType === '1' && columnIndex === 0) {
                return 'white-cell'
            } else {
                return ''
            }
        },
        tableRowClassName({ row, rowIndex }) {
            if (row.uploadUserType === '1') {
                return 'kp-update-row'
            }
            return ''
        },
        handleCurrentChange(val) {
            this.current = val
        },
        onSizeChange(size) {
            this.current = 1
            this.pageSize = size
        },
        calcVisibleIcon(row) {
            if (row.isEditVisible && row.isClientVisible) {
                return this.on_editable_icon
            }
            if (!row.isEditVisible && row.isClientVisible) {
                return this.on_uneditable_icon
            }
            if (row.isEditVisible && !row.isClientVisible) {
                return this.off_editable_icon
            }
            if (!row.isEditVisible && !row.isClientVisible) {
                return this.off_uneditable_icon
            }
        },
        canDownload(row) {
            if (!this.hasPermission('download')) {
                return false
            }
            if (row.createBy == this.getUser.userAccount) {
                return true
            }
            if (
                this.getUser.userType === '2' &&
                row.uploadUserType == '2' &&
                row.createBy !== this.getUser.userAccount &&
                !this.downloadAble
            ) {
                return false
            }

            return true
        },
        async onFilenameClick(row) {
            if (!this.canDownload(row)) return

            API.status.checkDownLoadLimit({
                siteId: this.getSite.siteId
            })

            const paramsdata = {
                siteId: this.getSite.siteId,
                fileId: row.id,
                source: 'statutory'
            }
            downloadSingleFile(paramsdata)
        },
        changeVisiableToClient(row) {
            if (!row.isEditVisible) return
            // 如果是客户上传的文件，则应该永远可见，且毕马威不可以更改为不可见
            if (row.uploadUserType === '2') return
            this.$confirm(
                row.isClientVisible ? this.$t('sas_confirm_set_invisible') : this.$t('sas_confirm_set_visible'),
                this.$t('COMMON_TIP'),
                {
                    confirmButtonText: this.$t('btn_confirm'),
                    cancelButtonText: this.$t('btn_cancel'),
                    type: 'warning'
                }
            ).then(() => {
                const form = new FormData()
                form.append('milestoneId', row.milestoneId)
                form.append('fileId', row.id)
                form.append('siteId', this.getSite.siteId)
                API.status
                    .switchAttachmentVisible(form)
                    .then((res) => {
                        if (res.code == '1') {
                            row.isClientVisible = !row.isClientVisible
                            this.$message.success(this.$t('msg_success'))
                        } else {
                            this.$t(res.code)
                        }
                    })
                    .catch((e) => {
                        console.error(e)
                        this.$message.error(this.$t('SYS_USER_003'))
                    })
                    .finally(() => {})
            })
        },
        close() {
            this.$emit('update:show', false)
        },
        /**
         * 判断文件是否可以删除
         */
        allowDelete(file) {
            if (file.milestoneRowValue.state > 0 && [1, 4].includes(file.milestoneRowValue.state)) {
                return false
            }
            if (this.getUser.userType === '1' && file.uploadUserType === '2') {
                return false
            }
            if (file.uploadUserType == this.getUser.userType || file.createBy == this.getUser.userAccount) {
                return true
            }

            return false
        },
        onDeleteClick(row) {
            this.$confirm(this.$t('sas_delete_file_text'), this.$t('delete_file'), {
                showConfirmButton: true,
                confirmButtonText: this.$t('btn_confirm'),
                confirmButtonClass: 'wl-green',
                showCancelButton: true,
                cancelButtonText: this.$t('comment_reSet'),
                cancelButtonClass: 'cancel-btn',
                closeOnClickModal: false,
                dangerouslyUseHTMLString: true,
                type: 'warning'
            }).then(() => {
                API.status
                    .deleteFiles({
                        siteId: this.getSite.siteId,
                        fileId: row.id
                    })
                    .then((res) => {
                        if (res.code === '1') {
                            this.$message.success(this.$t('msg_success'))
                            this.filelist.splice(
                                this.filelist.findIndex((v) => v.id == row.id),
                                1
                            )
                            this.reloadList()
                        } else {
                            this.$message.error(this.$t(res.code))
                        }
                    })
            })
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite',
            getUser: 'getUser'
        }),
        pageData() {
            return this.filelist.slice(this.pageSize * (this.current - 1), this.pageSize * (this.current - 1) + this.pageSize)
        }
    },
    watch: {
        show() {
            this.current = 1
        }
    }
}
</script>
<style scoped>
.filelist-container {
}
.visible_to_client-icon {
    width: 15px;
    height: 15px;
    cursor: pointer;
}
.visible_to_client-icon-uneditable {
    cursor: not-allowed;
}
.filename:hover {
    text-decoration: underline;
    cursor: pointer;
    color: #3879eb;
}
.filename .filename-icon {
    color: #3879eb;
    margin-right: 10px;
}
.filename-disable:hover {
    text-decoration: none;
    cursor: default;
    color: #636363;
}
.filename-disable .filename-icon {
    display: none;
}
.forkpmgonly {
    color: #bc4c4c;
    font-weight: 600;
}
::v-deep .kp-update-row {
    background: #0091da;
    color: #ffffff;
}
::v-deep .kp-update-row:hover {
    color: #93637c;
}
::v-deep .kp-update-row .el-icon-download {
    color: #ffffff;
}
::v-deep .kp-update-row:hover .el-icon-download {
    color: #3879eb;
}
::v-deep .white-cell {
    background-color: rgb(245, 247, 250);
}
.delete {
    color: #fd349c;
    cursor: pointer;
}
</style>
